<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="md"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >

            <template #modal-title>
                {{publication.title}}
            </template>

            <div class="mb-3">Select the items you'd like to export.
                <div class="d-flex align-items-center mb-2 mt-3">
                    <div>
                        <b-form-checkbox size="md" v-model="weeks" switch>
                            Weeks
                        </b-form-checkbox>
                        <b-form-checkbox size="md" v-model="articles" switch>
                            Articles
                        </b-form-checkbox>
                        <b-form-checkbox size="md" v-model="assessment_questions" switch>
                            Assessment questions
                        </b-form-checkbox>
                        <b-form-checkbox size="md" v-model="article_questions" switch>
                            Article questions
                        </b-form-checkbox>
                    </div>
                </div>
            </div>

            <template #modal-footer>
                <b-button variant="light" @click="cancel">
                    Close
                </b-button>
                <b-button variant="secondary" @click="exportJson">
                    <font-awesome-icon :icon="['fad', 'hockey-mask']" fixed-width /> Export JSON
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        weeks: true,
        articles: true,
        assessment_questions: true,
        article_questions: true,
        loading: false
    }),
    props: [
        'value',
        'publication'
    ],
    components: {},
    computed: {
        ...mapState({
            // validating: state => state.utilities.validating
        }),
        modal_id () {
            let modal_id = 'export-translation-json-modal'
            return modal_id
        }
    },
    watch: {},
    methods: {
        exportJson() {
            this.axios.post('/api/publications/export_json/' + this.publication.id, {
                weeks: this.weeks,
                articles: this.articles,
                assessment_questions: this.assessment_questions,
                article_questions: this.article_questions
            }, {
                responseType: 'blob'
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.publication.sku + '.json');
                document.body.appendChild(link);
                link.click();
            })
        },
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide () {
            this.$emit('hide')
        },
        hidden () {

        }
    }
}
</script>
